import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectOrganization } from 'state/Organization/organizationSlice';
import { selectUser } from 'state/User/userSlice';

import { init } from 'Services/intercom';

const useIntercom = (): boolean => {
  const [isIntercomInitialized, setIsIntercomInitialized] =
    useState<boolean>(false);

  const currentUser = useSelector(selectUser);
  const organization = useSelector(selectOrganization);

  useEffect(() => {
    if (currentUser && organization && !isIntercomInitialized) {
      init(currentUser, organization);
      setIsIntercomInitialized(true);
    }
  }, [currentUser, organization, isIntercomInitialized]);

  return isIntercomInitialized;
};

export default useIntercom;
